import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Dropdown, Button, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import TablePaginator from '../../../common/components/tablePaginator';
import {pageSizes} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {downloadFile} from '../../../common/util/file';

class VehiclesSalesDetail extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.VehiclesKpi,
        scopes.See
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    this.props.clearHistoricalVehiclesSalesDetail();
    const {isUserFromTDE, dealerId, dealer} = this.props;
    if (!isUserFromTDE && dealerId !== dealer) {
      this.props.addMessageBoxError(
        'Usted no puede visualizar la información solicitada'
      );
      return;
    }
    this.getSalesDetail();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.urlFile !== this.props.urlFile && this.props.urlFile) {
      downloadFile(this.props.urlFile);
      this.props.clearUrlFileForSalesDetail();
    }
  }

  getSalesDetail = () => {
    const {startDate, endDate, dealer, model} = this.props;
    const queryString = {
      startDate,
      endDate,
      dealer,
      model,
    };
    this.props.fetchHistoricalVehiclesSalesDetail(queryString);
  };

  onDownloadClick = () => {
    const {isUserFromTDE, dealerId, startDate, endDate, dealer, model} =
      this.props;
    this.props.clearUrlFileForSalesDetail();

    if (!isUserFromTDE && dealerId !== dealer) {
      this.props.addMessageBoxError(
        'No puede descargar la información solicitada'
      );
      return;
    }

    const queryString = {
      startDate,
      endDate,
      dealer,
      model,
    };
    this.props.downloadHistoricalVehiclesSalesDetail(queryString);
  }

  onPageClick = (value) => {
    this.props.changeSalesDetailListPage(value);
  }

  onPageSizeClick = (event, data) => {
    this.props.changeSalesDetailListPageSize(data.value);
  }

  renderDownloadButton = () => {
    const {isUserFromTDE, dealerId, dealer, downloading} = this.props;
    const allowUserDownload =
      isUserFromTDE || (!isUserFromTDE && dealerId === dealer);

    return (
      <Button
        type='button'
        primary
        className='toyota-primary download'
        disabled={downloading || !allowUserDownload}
        loading={downloading}
        onClick={this.onDownloadClick}
      >
        <Icon name='download' />
        Excel
      </Button>
    );
  }

  renderSalesDetail() {
    const {salesDetail} = this.props;
    if (!salesDetail.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={9}>
            No han sido encontradas ventas con esos filtros
          </Table.Cell>
        </Table.Row>
      );
    }
    return salesDetail.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.dealerName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.commercialName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderId}</Table.Cell>
          <Table.Cell textAlign='center'>{element.chassis}</Table.Cell>
          <Table.Cell textAlign='center'>{element.type}</Table.Cell>
          <Table.Cell textAlign='center'>{element.value}</Table.Cell>
          <Table.Cell textAlign='center'>{element.dealer}</Table.Cell>
          <Table.Cell textAlign='center'>{`${element.sfx} ${element.katashiki}`}</Table.Cell>
          <Table.Cell textAlign='center'>{element.colorName}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrSalesDetail = () => {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderSalesDetail();
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;
    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <div className='vehicles-sales-detail'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Detalle de Ventas de Vehículos</h2>
              <div className='title-bar-actions'>
                {this.renderDownloadButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>
                  Concesionario
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Nombre Comercial
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Pedido</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Chasis</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Valor</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Concesionario
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Katashiki
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Color</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderLoaderOrSalesDetail()}</Table.Body>

            {this.renderPagination()}
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {startDate, endDate, dealerId, modelName} = ownProps.params;

  return {
    'startDate': startDate === 'ALL' ? '' : startDate,
    'endDate': endDate === 'ALL' ? '' : endDate,
    'dealer': dealerId === 'ALL' ? '' : dealerId,
    'model': modelName === 'ALL' ? '' : modelName,
    'loading': state.vehiclesKpi.loading,
    'salesDetail': state.vehiclesKpi.salesDetailByPage,
    'pageNumber': state.vehiclesKpi.pageNumber,
    'pageSize': state.vehiclesKpi.pageSize,
    'totalItems': state.vehiclesKpi.salesDetail.length,
    'downloading': state.vehiclesKpi.downloading,
    'urlFile': state.vehiclesKpi.urlSalesDetailFile,
    'dealerId': state.session.dealerId,
    'isUserFromTDE': state.session.isUserFromTDE,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
  };
};

const {
  clearHistoricalVehiclesSalesDetail,
  fetchHistoricalVehiclesSalesDetail,
  changeSalesDetailListPage,
  changeSalesDetailListPageSize,
  clearUrlFileForSalesDetail,
  downloadHistoricalVehiclesSalesDetail,
  addMessageBoxError,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  clearHistoricalVehiclesSalesDetail,
  fetchHistoricalVehiclesSalesDetail,
  changeSalesDetailListPage,
  changeSalesDetailListPageSize,
  clearUrlFileForSalesDetail,
  downloadHistoricalVehiclesSalesDetail,
  addMessageBoxError,
})(VehiclesSalesDetail));
